import { CONDITION_FIELDS } from "../rule-sets/condition-field-config"

/**
 * Fields that resolve through the unconditional skillToTrade lookup. Surfacing them in
 * the conditional-trade picker would create a circularity (the conditional decides the
 * trade, but the condition itself reads the trade). They are filtered out of the picker
 * only in this context; rule sets continue to expose them as before.
 *
 * Kept in sync deliberately with CIRCULAR_FIELDS_FOR_CONDITIONAL_TRADES in
 * routes/rule-sets/server/condition-evaluator.mjs; that constant is server-side and
 * cannot be imported from a .js file, so we mirror the list here.
 */
const CIRCULAR_FIELDS = new Set(["trade", "hourlyRate", "estimatedAnnualCost"])

export const CONDITIONAL_TRADE_FIELDS = CONDITION_FIELDS.filter(isNotCircularField)

function isNotCircularField(f) {
    return f.value !== "specialistSet" && !CIRCULAR_FIELDS.has(f.value)
}
